import _ from 'underscore'
import React from 'react'
import PropTypes from 'prop-types'
import Sticker from './Sticker'

class LocationStickers extends React.PureComponent {
  render() {
    return (
      <React.Fragment>
        {_.map(this.props.stickers, (sticker, idx) => (
          <React.Fragment key={idx}>
            <Sticker
              foreground={sticker.color.foreground}
              background={sticker.color.background}
              noBorder={sticker.noBorder}
              text={sticker.name}
            />
            {'\n'}
          </React.Fragment>
        ))}
      </React.Fragment>
    )
  }
}

LocationStickers.propTypes = {
  stickers: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      color: PropTypes.shape({
        foreground: PropTypes.string.isRequired,
        background: PropTypes.string.isRequired
      }).isRequired,
      noBorder: PropTypes.bool
    }).isRequired
  ).isRequired
}

export default LocationStickers



// WEBPACK FOOTER //
// ./src/components/elements/LocationStickers.js